<template>
  <div>
    <v-dialog
        v-model="extendModalComp"
        max-width="640px"
        @click:outside="closeDialog"
    >
      <v-card class="rounded-lg" style="background-color: #F6F8FA">
        <v-card-title class="text-h5 font-weight-bold pb-4 pt-6" style="word-break: normal;">
          {{ $t('Tariffs.extend_tariff_name', {name: myTariffInfo.tariff ? myTariffInfo.tariff.name : '',
              count: myTariffInfo.tariff ? myTariffInfo.tariff.max_employees_qty : ''
            })
          }}
        </v-card-title>

        <v-card-text>
          <v-card flat class="px-2">
            <v-list>
              <v-list-item>
                <v-icon size="28" class="mr-4" :color="isExpired ? 'red' : 'primary'">
                  mdi mdi-calendar-text
                </v-icon>
                <v-list-item-content>
                  <v-list-item-title :class="{ 'red--text': isExpired }">
                    {{ myTariffInfo.period_info && myTariffInfo.period_info.usage_period_renew }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text--secondary">
                    {{ $t("Owners.extension_period") }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-icon size="28" class="mr-4" color="primary">
                  mdi mdi-account-supervisor-circle
                </v-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ myTariffInfo.tariff ? myTariffInfo.tariff.max_employees_qty : '' }}</v-list-item-title>
                  <v-list-item-subtitle class="text--secondary">
                    {{ $t("Tariffs.employees_count") }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-divider class="my-4"></v-divider>

              <v-switch
                  v-if="!(userInfo && userInfo.role === 'hr')"
                  v-model="useBonuses"
                  class="v-input--reverse v-input--expand px-4"
                  inset
                  persistent-hint
                  hide-details
              >
                <template #label>
                  <div class="d-flex flex-column">
                    <span :style="{ color: useBonuses ? '#4CAF50' : '#384046' }">{{ $t('Tariffs.spend_bonuses') }}</span>
                    <span style="color: #384046">{{ $t('Tariffs.saved') }}: {{ availableBonuses }}</span>
                  </div>
                </template>
              </v-switch>

              <v-divider v-if="!(userInfo && userInfo.role === 'hr')" class="my-4"></v-divider>

              <v-list-item v-if="userInfo && userInfo.role === 'hr'" style="border: 1px solid #F5D54C; border-radius: 5px; background-color: #F9F5DE">
                <v-icon color="#F5D44B">mdi mdi-information</v-icon>
                <span class="ml-2" style="color: #77511A">{{ $t('Tariffs.hr_cannot_use_bonuses') }}</span>
              </v-list-item>

              <!-- Old price -->
              <v-list-item v-if="myTariffInfo.period_info && myTariffInfo.period_info.discount && myTariffInfo.period_info.discount !== 0">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ myTariffInfo.period_info.old_price }}
                    /{{ myTariffInfo.period_info.month }}
                    {{ $t('Tariffs.month') }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text--secondary">
                    {{ $t('Tariffs.price') }} "{{
                      $t('Tariffs.tariff_name_emp', {
                        name: myTariffInfo.tariff ? myTariffInfo.tariff.name : '',
                        count: myTariffInfo.tariff ? myTariffInfo.tariff.max_employees_qty : ''
                      })
                    }}"
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <!-- Price with discount -->
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ myTariffInfo.period_info ? myTariffInfo.period_info.price : '' }}
                    /{{ myTariffInfo.period_info ? myTariffInfo.period_info.month : '' }}
                    {{ $t('Tariffs.month') }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text--secondary">
                    {{ $t('Tariffs.price') }} "{{
                      $t('Tariffs.tariff_name_emp', {
                        name: myTariffInfo.tariff ? myTariffInfo.tariff.name : '',
                        count: myTariffInfo.tariff ? myTariffInfo.tariff.max_employees_qty : ''
                      })
                    }}"
                    <span v-if="myTariffInfo.period_info && myTariffInfo.period_info.discount && myTariffInfo.period_info.discount !== 0">
                      <template v-if="$i18n.locale === 'kk'">
                        <span style="color: red">{{ myTariffInfo.period_info.discount }}%</span> жеңілдікпен
                      </template>
                      <template v-else>
                        со скидкой <span style="color: red">{{ myTariffInfo.period_info.discount }}%</span>
                      </template>
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="useBonuses && hasBonuses">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ usedBonuses }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text--secondary">
                    {{ $t('Tariffs.with_bonuses') }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content class="primary--text">
                  <div class="font-weight-bold">{{ $t('Tariffs.total') }}</div>
                  <div class="text-h4 font-weight-bold">
                    {{ totalPrice }}
                  </div>
                </v-list-item-content>
              </v-list-item>

            </v-list>
          </v-card>
        </v-card-text>

        <v-card-actions class="justify-end pa-4">
          <v-btn
              class="font-16px px-6"
              color="main_color"
              outlined
              min-height="52"
              @click="closeDialog"
          >
            {{ $t('Default.back') }}
          </v-btn>
          <v-btn
              class="primary ml-4 text-capitalize font-16px px-6"
              min-height="52"
              :loading="loading"
              :disabled="loading"
              @click="extendTariff"
          >
            {{ $t('Default.accept') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <SuccessTariffDialog
        v-model="isSuccessDialogOpen"
        :text="$t('Tariffs.success_continue')"
    />
    <ErrorTariffDialog
        v-model="isErrorDialogOpen"
        :error-text="errorText"
    />
  </div>
</template>

<script>
import { computed, ref } from "@vue/composition-api";
import { useStore } from "vuex-composition-helpers";
import { DispatchTypes } from "@/store/modules/admin/tariffs/types";
import { periodsMap } from "@/store/modules/admin/tariffs/data";
import SuccessTariffDialog from "@/pages/client/Tariffs/components/SuccessTariffDialog.vue";
import ErrorTariffDialog from "@/pages/client/Tariffs/components/ErrorTariffDialog.vue";
import { globalVariables } from "@/utility/variables";

export default {
  name: "ExtendTariffModal",
  props: {
    extendModal: Boolean,
    tariff_info: Object,
  },
  components: {
    SuccessTariffDialog,
    ErrorTariffDialog
  },
  setup(props, { root, emit }) {
    const store = useStore();
    const { userInfo } = globalVariables();

    const isSuccessDialogOpen = ref(false);
    const isErrorDialogOpen = ref(false);
    const errorText = ref("");
    const loading = ref(false);
    const useBonuses = ref(false);

    const extendModalComp = computed({
      get() {
        return props.extendModal;
      },
      set(value) {
        return emit("close", value);
      },
    });

    const isExpired = computed(() => {
      return props.tariff_info && props.tariff_info.status === 'expired';
    });

    const hasBonuses = computed(() => {
      if (!props.tariff_info || !props.tariff_info.period_info) return false;

      const bonuses = props.tariff_info.period_info.renew_used_bonuses;
      return bonuses && bonuses !== "0" && bonuses !== "";
    });

    const availableBonuses = computed(() => {
      if (!props.tariff_info || !props.tariff_info.period_info || !props.tariff_info.period_info.renew_used_bonuses) return '0 ₸';
      const bonusValue = props.tariff_info.period_info.renew_used_bonuses.replace('-', '');
      return bonusValue.includes('₸') ? bonusValue : `${bonusValue} ₸`;
    });

    const usedBonuses = computed(() => {
      if (!props.tariff_info || !props.tariff_info.period_info) return '0';
      return props.tariff_info.period_info.renew_used_bonuses || '0';
    });

    const totalPrice = computed(() => {
      if (!props.tariff_info || !props.tariff_info.period_info) return '';

      if (useBonuses.value && props.tariff_info.period_info.total_renew_with_bonuses) {
        return props.tariff_info.period_info.total_renew_with_bonuses;
      }

      return props.tariff_info.period_info.price;
    });

    const closeDialog = () => {
      emit("close", false);
    };

    const extendTariff = async () => {
      try {
        loading.value = true;
        const company = store.state.auth.UserInfo.selected_company_id;
        const payload = {
          company,
          is_instant_apply: false,
          period: props.tariff_info && props.tariff_info.period_info ? props.tariff_info.period_info.id : null,
          tariff: props.tariff_info && props.tariff_info.tariff ? props.tariff_info.tariff.id : null,
          use_bonuses: useBonuses.value
        };
        const res = await store.dispatch(DispatchTypes.changeTariff, payload);
        if (res.message === "created") {
          isSuccessDialogOpen.value = true;
          extendModalComp.value = false;
        }
      } catch (e) {
          console.error('Error:', e.message);
          errorText.value = e.message;
          isErrorDialogOpen.value = true;
      } finally {
        loading.value = false;
      }
    };

    return {
      extendModalComp,
      myTariffInfo: props.tariff_info,
      extendTariff,
      loading,
      isSuccessDialogOpen,
      isErrorDialogOpen,
      errorText,
      isExpired,
      hasBonuses,
      periodsMap,
      closeDialog,
      useBonuses,
      availableBonuses,
      usedBonuses,
      totalPrice,
      userInfo
    };
  },
};
</script>

<style scoped>
.red-icon {
  filter: brightness(0) saturate(100%) invert(15%) sepia(90%) saturate(6500%) hue-rotate(359deg) brightness(108%) contrast(113%);
}

::v-deep .v-btn.v-btn--outlined {
  border-color: #116ACC !important;
  color: #116ACC !important;
  text-transform: capitalize !important;
}

::v-deep .v-btn.v-btn--outlined:hover::before,
::v-deep .v-btn.v-btn--outlined:focus::before {
  opacity: 0 !important;
}

::v-deep .v-btn.v-btn--outlined:hover {
  background-color: transparent !important;
}

::v-deep .v-input--reverse .v-input__slot {
  justify-content: space-between;
}
</style>